import { faArrowLeft, faFolderOpen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../../AuthProvider';
import Divider from '../../../../components/Divider';
import FileExplorer from '../../../../components/FileExplorer/file-explorer';
import Role from '../../../../enums/RoleEnum';
import CaseStepType from '../../../../types/CaseStepType';
import CaseType from '../../../../types/CaseType';
import CaseActions from './caseActions';
import CaseDescription from './caseDescription';
import CaseFormResponses from './caseFormResponses';
import JudicialCalendar from './caseJudicialCalendar';
import CaseNotes from './caseNotes';
import PersonnalData from './casePersonnalData';
import CaseSteps from './caseSteps';
import styles from './style.module.scss';

interface Props {
    userCase: CaseType;
    caseId: string;
    basePath: string;
}

function CaseDetails(props: Props) {
    const { userCase, caseId, basePath } = props;
    const { user } = useAuth();

    const steps: CaseStepType[] = [
        {
            id: 'step1',
            label: 'Création du dossier',
            date: new Date('2024/04/02 12:34:56'),
            status: 'start',
        },
        {
            id: 'step2',
            label: 'Consultation',
            date: new Date('2024/04/04 15:30:00'),
            status: 'in progress',
        },
        {
            id: 'step3',
            label: 'Audience préliminaire',
            date: new Date('2024/04/05 09:40:36'),
            status: 'in progress',
        },
        {
            id: 'step4',
            label: 'Dépot de documents',
            date: new Date('2024/04/09 18:34:45'),
            status: 'end',
        },
    ];

    return (
        <div className={styles.body}>
            <div className={styles.header}>
                <Link to={basePath}>
                    <FontAwesomeIcon icon={faArrowLeft} />
                </Link>
                <h1>
                    <span className={styles.headerIcon}>
                        <FontAwesomeIcon icon={faFolderOpen} />
                    </span>
                    Dossier {userCase?.caseRef}
                </h1>
            </div>
            <Divider marginBottom="20px" />
            <CaseActions userCase={userCase} />
            <CaseDescription clientCase={userCase} />
            <PersonnalData caseData={userCase} />
            <CaseFormResponses clientCase={userCase} />
            {/* <CaseLaws /> */}
            <JudicialCalendar clientCaseId={caseId} />
            <CaseSteps caseSteps={steps} />

            {user?.role === Role.Lawyer && <CaseNotes clientCase={userCase} />}
            <div className={styles.infoContainer}>
                <h2>Fichiers:</h2>
                <FileExplorer />
            </div>
        </div>
    );
}

export default CaseDetails;
